import { makeVar } from '@apollo/client'

export const currentMarketIdVar = makeVar('')
export const currentLanguageIdVar = makeVar('')
export const currentLanguageCodeVar = makeVar('')
